<template>
    <a-button @click="onCall($user.role)" intent="icon" as="a" :href="'tel:' + props.order.customer_phone" icon="solar:phone-bold-duotone"
        class="tw-min-w-[100px]x !tw-bg-sky-500 !tw-text-white"></a-button>
</template>

<script setup>
import { call } from '@/api/orders';
import { defineProps, ref } from 'vue';

const props = defineProps(['order']);
const called = ref(false);
called

const onCall = (role) => {
    call(props.order.id, role == 'admin' ? 'agent' : role)
    .then(
        res => {
            console.log(res.data)
        }
    )
}
</script>

<style>

</style>